export default "__VITE_ASSET__ajDvZ1dp__"